import clsx from "clsx";
import type { ItemProps } from "./item.types";

import { ComboboxOption } from "@headlessui/react";
import { forwardRef } from "react";
import classes from "./item.module.css";

/**
 * Combobox item component.
 *
 * @author Adam Halasz
 * @category Components
 * @see ItemProps
 */
const Item = forwardRef<HTMLDivElement, ItemProps>(
  ({ label, icon, onClick, className, query, value }, ref) => {
    const safeLabel = typeof label === "string" ? label : "";
    return (
      <ComboboxOption
        ref={ref}
        value={value}
        className={clsx(
          "prose-paragraph-14-regular flex select-none items-center",
          classes["combobox-option"],
          className
        )}
        onClick={onClick}
      >
        {icon}
        {query ? (
          <span
            dangerouslySetInnerHTML={{
              __html: safeLabel.replace(
                new RegExp(`(${query})`, "gi"),
                "<strong>$1</strong>"
              ),
            }}
          />
        ) : (
          safeLabel
        )}
      </ComboboxOption>
    );
  }
);

Item.displayName = "Item";

export { Item };
